<template>
  <div class="deep-dive-container">
    <div class="header">
      <img
        @click="changeDeepDiveState()"
        id="go-to-exploration-button"
        src="../assets/close_deep_dive.png"
        alt="go to exploration modal"
      />
      <img
        @click="
          changeDeepDiveState();
          changeExplorationState();
        "
        id="deep-dive-close-button"
        src="../assets/close_button.png"
        alt="close deep-dive and exploration modal"
      />
    </div>
    <h2>Mentions</h2>
    <SpeakerCard />
    <ChunkCard class="chunk-card-deep-dive"></ChunkCard>
  </div>
</template>

<script>
import ChunkCard from "../components/ChunkCard.vue";
import SpeakerCard from "../components/SpeakerCard.vue";

export default {
  name: "DeepDive",
  components: {
    ChunkCard,
    SpeakerCard,
  },
  data() {
    return {};
  },
  computed: {
    deepDiveVisible() {
      return this.$store.state.deepDiveVisible;
    },
    exolorationVisible() {
      return this.$store.state.explorationVisible;
    },
  },
  methods: {
    changeDeepDiveState() {
      this.$store.commit("toggleDeepDive");
    },
    changeExplorationState() {
      this.$store.commit("toggleExploration");
    },
  },
};
</script>

<style scoped>
.deep-dive-container {
  background-color: rgb(15, 15, 15);
  height: 90vh;
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 2;
  margin: 0px;
}

#deep-dive-close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
}

#go-to-exploration-button {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 30px;
}

.header {
  height: 100px;
}

h2 {
  font-size: 16px;
  padding-left: 30px;
  border-bottom: 1px solid rgb(87, 87, 87);
  padding-bottom: 15px;
}

.chunk-card-deep-dive {
  margin: 0px 30px 5px 50px;
}
</style>